import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
// ─────────────────────────────────────────────────────────────
// 👇 PEGÁ ACÁ EL LINK DE YOUTUBE PARA MOSTRAR EL VIDEO
//    Ejemplos válidos:
//      'https://www.youtube.com/watch?v=XXXXXXXXXXX'
//      'https://youtu.be/XXXXXXXXXXX'
//    Dejalo vacío ('') para seguir viendo el placeholder.
// ─────────────────────────────────────────────────────────────
const YOUTUBE_URL = 'https://www.youtube.com/watch?v=l0DV_5MEk_I';
/** Extrae el ID del video desde cualquier formato de link de YouTube */
function getYouTubeId(url: string): string | null {
  if (!url) return null;
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return match ? match[1] : null;
}
export function VideoSection() {
  const videoId = getYouTubeId(YOUTUBE_URL);
  return <section className="py-24 px-6 relative" data-id="element-99">
      <div className="max-w-5xl mx-auto" data-id="element-100">
        <div className="text-center mb-12" data-id="element-101">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-6" data-id="element-102">
            Mirá esto antes de empezar
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-103">
            En este video te cuento cómo funciona la mentoría, qué vas a
            construir y por qué tener una guía clara puede ahorrarte meses de
            prueba, error e improvisación.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative aspect-video w-full rounded-2xl border border-brand-gold/20 bg-brand-card overflow-hidden gold-border-glow" data-id="element-104">
          {videoId ? <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${videoId}`} title="Video introductorio" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-105" /> : <div className="absolute inset-0 flex flex-col items-center justify-center bg-brand-darker/80 backdrop-blur-sm z-10" data-id="element-106">
              <div className="w-20 h-20 rounded-full bg-brand-gold/20 flex items-center justify-center mb-4" data-id="element-107">
                <div className="w-16 h-16 rounded-full bg-brand-gold flex items-center justify-center" data-id="element-108">
                  <Play className="w-8 h-8 text-brand-darker ml-1" data-id="element-109" />
                </div>
              </div>
              <p className="text-brand-goldLight font-medium px-4 text-center" data-id="element-110">
                Video introductorio de YouTube
              </p>
              <p className="text-brand-muted text-sm px-6 text-center mt-2 max-w-md" data-id="element-111">
                Abrí el archivo{' '}
                <span className="text-brand-goldLight font-semibold" data-id="element-112">
                  components/VideoSection.tsx
                </span>{' '}
                y pegá el link de tu video en{' '}
                <span className="text-brand-goldLight font-semibold" data-id="element-113">
                  YOUTUBE_URL
                </span>{' '}
                para mostrarlo acá automáticamente.
              </p>
            </div>}
        </motion.div>
      </div>
    </section>;
}